module.exports = __webpack_public_path__ + "media/Another Age.84951e03.mp3";